import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useCallback, useEffect, useState } from 'react';
import Services from '../../../Services/services';
import PaymentMethods from './PaymentMethods';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function PaymentElements(props) {
  const [clientSecret, setClientSecret] = useState();

  const fetchClientSecret = useCallback(async () => {
    const userSetupSecret = await Services.userService.userStripeSetup(
      props?.expert?.userId,
      props?.expert?.stripeId
    );

    setClientSecret(userSetupSecret);
  }, [props]);

  useEffect(() => {
    fetchClientSecret();
  }, [fetchClientSecret]);

  return (
    <>
      {clientSecret && (
        <Elements
          stripe={stripePromise}
          options={{ clientSecret, currency: 'eur' }}
        >
          <PaymentMethods clientSecret={clientSecret} />
        </Elements>
      )}
    </>
  );
}

export default PaymentElements;
